import { FC, useMemo } from 'react';
import { parseMarkedText } from '@/shared/lib';
import { CommentTextLines } from '../CommentTextLines';
import { ATTR_COMMENT_MARKERS } from '../commentMarkers';
import { TimeFragmentLink } from '../TimeFragmentLink';

type Props = { comment: string };

export const AttrCommentText: FC<Props> = ({ comment }) => {
  const parts = useMemo(() => parseMarkedText(comment, ATTR_COMMENT_MARKERS), [comment]);

  return (
    <span>
      {parts.map((part, index) =>
        part.kind === 'text' ? (
          <CommentTextLines key={index} text={part.text} />
        ) : (
          <TimeFragmentLink key={index} time={part.marker.time}>
            {part.marker.text}
          </TimeFragmentLink>
        ),
      )}
    </span>
  );
};
